(function () {
  'use strict';
  const frame = document.getElementById('runescope-live-frame');
  if (!frame) return;
  const query = new URLSearchParams(location.search);
  if (query.get('view') === 'wyrd') return;
  const names = new Set('Fehu Uruz Thurisaz Ansuz Raidho Kenaz Gebo Wunjo Hagalaz Nauthiz Isa Jera Eihwaz Perthro Algiz Sowilo Teiwaz Berkano Ehwaz Mannaz Laguz Ingwaz Othala Dagaz'.split(' '));
  const target = new URL(frame.src);
  if (target.origin !== 'https://runescope-private-preview-df4seqav3a-nw.a.run.app') return;
  for (const key of ['birth', 'fate']) {
    if (names.has(query.get(key))) target.searchParams.set(key, query.get(key));
  }
  if (['en', 'is', 'pt', 'pl'].includes(query.get('lang'))) target.searchParams.set('lang', query.get('lang'));
  if (query.get('unknown_time') === '1' && names.has(query.get('birth'))) target.searchParams.set('unknown_time', '1');
  if (target.href !== frame.src) frame.src = target.href;
})();
